'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

UrlParamService.$inject = ['WindowLocation'];


var _module = _angular2.default.module('cb.util.UrlParamService', []);

_module.factory('UrlParamService', UrlParamService);

exports.default = _module;


function UrlParamService(WindowLocation) {
    var service = {
        getUrlParam: getUrlParam,
        urlEncode: urlEncode
    };

    return service;

    /**
     * Get URL parameter.
     *
     * @param {String} name
     * @returns {string}
     */
    function getUrlParam(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(WindowLocation.getSearch());
        return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    /**
     * Encode params to URL query string
     *
     * @param params
     * @returns {string}
     */
    function urlEncode(params) {
        return (0, _keys2.default)(params).map(function (key) {
            return [key, _angular2.default.isDefined(params[key]) ? params[key] : ''].map(encodeURIComponent).join('=');
        }).join('&');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/url-param.service.js
// module id = 832
// module chunks = 0